module.exports = __webpack_public_path__ + "9067281741ae2aeabb1c8537b7a41b7f.svg";